import React, { FC, useState } from 'react';
import { useGetProgramMasterData } from 'src/api/mutations/useGetProgramMasterData';
import './IncreaseStrengthSteps.scss'; // Reusing the same SCSS for consistency
import { ReactComponent as ConditioningIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/conditioning.svg';
import { ReactComponent as EnduranceIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/performance-endurance.svg';
import { ReactComponent as StrengthIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/strength.svg';
import { ReactComponent as AgilityIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/agility.svg';
import { ReactComponent as PowerIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/power.svg';
import { ReactComponent as SpeedIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/speed.svg';

interface PerformanceStep2Props {
  value?: string;
  onNext?: (value: string) => void;
}

const iconMap: Record<string, React.ReactNode> = {
  strength: <StrengthIcon />,
  power: <PowerIcon />,
  speed: <SpeedIcon />,
  agility: <AgilityIcon />,
  conditioning: <ConditioningIcon />,
  endurance: <EnduranceIcon />,
};

// What is the performance focus for this program?
export const PerformanceStep2: FC<PerformanceStep2Props> = ({ value, onNext }) => {
  const [selectedFocus, setSelectedFocus] = useState<string>(value || '');
  const { data: programMasterData, isLoading, isError } = useGetProgramMasterData();

  const groupData = programMasterData?.trainingGoalPreferences?.groups?.find(
    (g: any) => g.goalId === 'performance',
  );

  const focuses = groupData?.options
    ? [...groupData.options].sort((a: any, b: any) => a.order - b.order)
    : [];

  if (isLoading) {
    return <div className="increase-strength-step">{'Loading options...'}</div>;
  }

  if (isError || !groupData) {
    return <div className="increase-strength-step">{'Error loading options.'}</div>;
  }

  return (
    <div className="increase-strength-step">
      <h2 className="step-title">{groupData?.title}</h2>

      <div className="goal-buttons">
        {focuses.map((focus: any) => (
          <button
            key={focus.id}
            className={`goal-btn ${selectedFocus === focus.slug ? 'selected' : ''}`}
            onClick={() => {
              setSelectedFocus(focus.slug);
              if (onNext) onNext(focus.slug);
            }}
          >
            <div className="goal-icon">{iconMap[focus.id]}</div>
            <span className="goal-label">{focus.title}</span>
          </button>
        ))}
      </div>
    </div>
  );
};
